









































































import Vue from "vue";
import { computed, ref } from "@vue/composition-api";
import { common_state } from "../data/common.state";
import AppCheckbox from "@/components/AppCheckbox.vue";
import Search from "@/components/Search.vue";
import { LABEL_PROVIDERS } from "../data/provider";
export default Vue.extend({
  props: ["value", "has_match"],
  components: {
    AppCheckbox,
    Search,
  },
  setup() {
    const { state } = common_state;
    const query = ref("");
    const mip_labels = computed(() => {
      if (state.mipLabelsTree && state.mipLabelsTree.length) {
        const arr = state.mipLabelsTree.flat(1);
        return [
          ...arr.filter((l) => !l.parentId && !l.hasChildren),
          ...arr.filter((l) => !(!l.parentId && !l.hasChildren)),
        ];
      }
      return [];
    });

    // Google labels are flat, so they need none of the parent/child ordering
    // the Microsoft tree above does.
    const selected_service_labels = computed(() =>
      state.provider === "google" ? state.google_labels : mip_labels.value
    );

    const displayed_labels = computed(() => {
      if (query.value.length > 0) {
        const term = new RegExp(query.value, "i");
        return selected_service_labels.value.filter(
          (l) => l.labelName.search(term) > -1
        );
      }
      return selected_service_labels.value;
    });

    return {
      query,
      mip_labels,
      selected_service_labels,
      displayed_labels,
      provider_config: computed(() => LABEL_PROVIDERS[state.provider]),
    };
  },
});
